export class ManualGlueProductivityCost {
  itemGlueId = -1;
  boxTypeId = 0;
  cost = 0;
}

export class MachineGlueCost {
  itemGlueId = -1;
  boxTypeId = 0;
  quantityFrom = 1;
  quantityTo = -1;
  cost = 0;
}

export class MachineGlueFixedFormCost {
  id?: number;
  sheetFrom = 1;
  sheetTo = -1;
  itemGlueId = 0;
  paperBugFixedFormId = 0;
  cost = 0;
}
export class PaperColorCost {
  id?: number;
  sheetFrom = 0;
  sheetTo = -1;
  paperTypeId = 0;
  paperColorId = 0;
  itemPaperSizeId = 0;
  cost = 0;
  lineNo?: number;
}
export class PaperCost {
  id?: number;
  paperTypeId = 0;
  cost = 0;
  itemPaperSizeId = 0;
}
export class MachineGlueBoxUnitCost {
  id?: number;
  boxTypeId = 0;
  cost = 0;
  itemGlueId = -1;
}
